var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.875 23.4C43.3365 23.4 42.9 23.8365 42.9 24.375V53.625C42.9 54.1635 43.3365 54.6 43.875 54.6H51.675C52.2135 54.6 52.65 54.1635 52.65 53.625V24.375C52.65 23.8365 52.2135 23.4 51.675 23.4H43.875ZM26.3251 23.4C25.7866 23.4 25.3501 23.8365 25.3501 24.375L25.3501 53.625C25.3501 54.1635 25.7866 54.6 26.3251 54.6H34.1251C34.6636 54.6 35.1001 54.1635 35.1001 53.625L35.1001 24.375C35.1001 23.8365 34.6636 23.4 34.1251 23.4H26.3251Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.12cc554c906ffa749edfe7f6893b553b.svg";
export { ForwardRef as ReactComponent };